export const downloadFileFromUrl = (url: string): void => {
    if (!url) {
        return;
    }
    const win = window.open(url);
    if (!win) {
        throw new Error('File download is blocked by your browser');
    }
};
